<template>
    <div class="flex items-center justify-center w-full">
        <div v-if="imagePreviewUrl">
            <img
                class="w-full h-64 object-cover rounded-lg"
                :src="imagePreviewUrl"
                alt="Preview"
            />
        </div>
        <label
            :class="[
                'flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer',
                { 'bg-gray-50 hover:bg-gray-100 border-gray-300': !disabled, 'bg-gray-200 border-gray-200 cursor-not-allowed': disabled },
            ]"
            for="dropzone-file"
            @dragover.prevent="disabled ? null : onDragOver"
            @dragleave.prevent="disabled ? null : onDragLeave"
            @drop.prevent="disabled ? null : onFileDrop"
        >
            <div class="flex flex-col items-center justify-center pt-5 pb-6">
                <svg
                    class="w-8 h-8 mb-4 text-gray-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                >
                    <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                </svg>
                <p class="mb-2 text-sm text-gray-500"><span class="font-semibold">Click to upload</span> or drag and drop</p>
                <p class="text-xs text-gray-500">SVG, PNG, or JPG</p>
            </div>
            <input
                id="dropzone-file"
                ref="fileInput"
                type="file"
                class="hidden"
                :disabled="disabled"
                @change="handleFileUpload"
            />
        </label>
    </div>
</template>

<script>
export default {
    name: 'FileUpload',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            file: null, // This will hold the selected file
            imagePreviewUrl: null, // This will hold the image preview URL
        };
    },
    methods: {
        handleFileUpload(event) {
            if (this.disabled) {
                console.log('Component is disabled, file upload not allowed');
                return;
            }
            const files = event.target.files;
            if (files.length > 0) {
                this.file = files[0];
                console.log('Selected file:', this.file);
                this.previewFile();
                this.$emit('uploaded', this.file);
            }
        },
        previewFile() {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.imagePreviewUrl = e.target.result;
            };
            reader.readAsDataURL(this.file);
        },
        onDragOver(event) {
            event.currentTarget.style.borderColor = 'blue';
        },
        onDragLeave(event) {
            event.currentTarget.style.borderColor = '';
        },
        onFileDrop(event) {
            // Create a mock event object if the real one is structured differently
            const files = event.dataTransfer.files;
            if (files.length) {
                this.handleFileUpload({ target: { files } });
            }
        },
    },
};
</script>
